<div class="container-fluid border py-4">
    <div class="row">
        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-between align-items-between h-100">
                <div class="">
                    <h3 class="pt-4"><i>Sphere of influence calculator</i></h3>
                    <span class="footnote">Nearby Frontline community results and demographic data</span>
                    <div class="pt-5 px-0 col-12 col-lg-9">
                        <div class="py-4">Here are communities closest to the zip codes you entered
                            that are likely to be frontline communities. If your zip code is a frontline community, it
                            will be included in the list below.</div>
                    </div>
                </div>
                <div class="">
                    <div class="pb-3">From <span class="text-blue">Sphere of Influence course.</span></div>
                    <a role="button" class="btn btn-primary" (click)="onViewFullResults()">view full results</a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="row mt-4 mt-lg-0" *ngFor="let result of results; let i=index">
                <div class="col-12 col-lg-10">
                    <div [ngClass]="{'row align-items-center justify-content-between py-3': true, 'border-top' : i > 0 }">
                        <div class="col-8 text-xlarge"><b>{{result.zip}} is likely to be a frontline community</b> with
                            a
                            score of
                            {{result.score}} out of
                            10.</div>
                        <div class="col-4 text-xlarge text-center pl-2">
                            <div class="soi-number-container">
                                <span class=" soi-number">{{result.score| number:'1.1-1'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>